import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { SnpDeduction } from '../entities/snp-deduction';

@Injectable()
export class SnpDeductionService extends BaseCrudService<SnpDeduction> {

  public uri = '/api/snpDeduction/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance SnpDeductionService');
  }

  buildSentence(entity?: SnpDeduction, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.percentage1 ?
          `percentage1${QueryOperator.Contain}${entity.percentage1}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.percentage2 ?
          `percentage2${QueryOperator.Contain}${entity.percentage2}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.sequence ?
          `sequence${QueryOperator.Contain}${entity.sequence}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.payrollConcept) {
        query = query.concat(entity.payrollConcept.id ?
          `payrollConcept.id${QueryOperator.Equal}${entity.payrollConcept.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.payrollConcept.code ?
          `payrollConcept.code${QueryOperator.Contain}${entity.payrollConcept.code}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.payrollConcept.name ?
          `payrollConcept.name${QueryOperator.Contain}${entity.payrollConcept.name}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.payrollConcept && entity.payrollConcept.fiscalYear ?
          `payrollConcept.fiscalYear.id${QueryOperator.Equal}${entity.payrollConcept.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(entity.payrollConcept && entity.payrollConcept.executingUnit ?
          `payrollConcept.executingUnit.id${QueryOperator.Equal}${entity.payrollConcept.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/snp-deduction.service.ts